import Vue from 'vue'
import Router from 'vue-router'
import { getToken, toLogin } from 'chaos-sso-util'
import {isFrame} from "../utils/other";
const CALL_PAGE_NAME = 'codeCallback'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/*iframe 嵌套逻辑*/
let h = import('../pages/home')
if(isFrame()){
  h = import('../pages/homeFrame')
}

Vue.use(Router);
var router = new Router({
  base:"/skillmap/",
  mode: 'history',
  routes: [
    // {path: '/', redirect: '/login'},
    {path: '/', redirect: '/workload/welcome'},
    // {path: '/login', name: 'login', component: () => import('../pages/login/LoginTrain')},
    {path: '/skillCollection', name: 'skillCollection', component: () => import('../pages/skill')},
    {
      path: '/workload',
      /*iframe 嵌套逻辑*/
      component: () => h,
      children: [
        {path: '', redirect: 'welcome'},
        {path: 'welcome', name: 'Home', component: () => import('../pages/others/welcome')},
        {path: 'task/todo', component: () => import('../pages/task/todo')},
        {
          path: 'task/review',
          component: () => import('../pages/task/reviewList'),
          children: [
            {path: ':id', component: () => import('../components/slideDrawer/applicationDrawer')}
          ]
        },
        {
          path: 'mySkill/base',
          component: () => import('../pages/myView/baseInfo')
        },
        {
          path: 'mySkill/view',
          component: () => import('../pages/myView/skillView'),
          children: [
            {path: ':id', component: () => import('../components/slideDrawer/applicationDrawer')},
            {path: 'batch/:id', component: () => import('../components/slideDrawer/batchApplyDrawer')}
          ]
        },
        {
          path: 'mySkill/record',
          name: 'mySkill',
          component: () => import('../pages/myView/applicationRecords'),
          children: [
            {path: ':id', component: () => import('../components/slideDrawer/applicationDrawer')},
            {path: 'batch/:id', component: () => import('../components/slideDrawer/batchApplyDrawer')}
          ]
        },
        {
          path: 'setting/class',
          component: () => import('../pages/setting/skillSetting'),
          children: [
            {path: ':id', component: () => import('../components/slideDrawer/skillDrawer')}
          ]
        },
        {path: 'setting/organization', component: () => import('../pages/setting/organizationSetting')},
        {path: 'setting/capacity', component: () => import('../pages/setting/capacitySetting')},
        {path: 'setting/employee', component: () => import('../pages/setting/employeeSetting')},
        {path: 'setting/nopush', component: () => import('../pages/setting/noPush')},
        {path: 'setting/feedback', component: () => import('../pages/setting/managerFeedback')},
        {path: 'setting/exportWeek', component: () => import('../pages/setting/exportWeek')},
        {
          path: 'setting/waitingReviews',
          component: () => import('../pages/setting/waitingReviews'),
          children: [
            {path: ':id', component: () => import('../components/slideDrawer/applicationDrawer')}
          ]
        },
        {path: 'report/project', component: () => import('../pages/report/projectReport')},
        {path: 'report/department', component: () => import('../pages/report/departmentReport')},
        {path: 'report/center', component: () => import('../pages/report/centerReport')},
        {path: 'report/source', component: () => import('../pages/report/sourceReport')},
        {path: 'report/sourceTable', component: () => import('../pages/report/sourceTable')},
        {path: 'report/employee', component: () => import('../pages/report/employeeContent')},
        {path: 'system/role', component: () => import('../pages/system/role')},
        {path: 'system/userLevel', component: () => import('../pages/system/userLevel')},
        {
          path: "/codeCallback",
          name: "codeCallback",
          component: () => import("@/pages/callback/CodeCallbackContainer"),
          hidden: true
        }
      ]
    },
    {path: '*', redirect: '/workload/welcome'}
  ]
});
// 路由登录校验
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.name === CALL_PAGE_NAME) {
    next() // 跳转
  } else if (!token) {
    /*iframe 嵌套逻辑*/
    if(isFrame()){
      next({ path: '/codeCallback' })
    }
    else{
      toLogin()
    }


  } else if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断当前的token是否存在
    if (token) {
      next()
    } else {
      next({ path: '/' })
    }
  } else {
    next()
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js